// extracted by css-extract-rspack-plugin
export default {"title":"OCphicXaYs08zluH__title___","section":"lRNpK_D6TIwwDGGv__section___","cpvCode":"VwkclzrkFdcaCakh__cpvCode___","cpvCodesContainer":"VdBbOrK1GUYf0zjf__cpvCodesContainer___"};